<template>
<div class="date-filters">
  <date-picker :class="'date-picker-'+headerGradient" :max="maxStartDateValue" v-if="showStartDate" @close="showStartDate = false" v-model="startDateValue" @input="startDateChanged" :format="formatDate"/>
  <date-picker :class="'date-picker-'+headerGradient" :min="minEndDateValue" :max="maxEndDate" v-if="showEndDate" @close="showEndDate = false" v-model="endDateValue" @input="endDateChanged" :format="formatDate"/>
  <i class="icon-calendar"/>
  <underlined-input type="text" color="grey" v-model="startDateValue" :onClick=" () => showStartDate = true" :placeholder="startPlaceholder"/>
  <i class="material-icons small-font" v-show="typeof startDate !== 'undefined' && startDate !== null" v-on:click="removeStartDate">close</i>
  <span> - </span>
  <underlined-input type="text" color="grey" v-model="endDateValue" :onClick="() => showEndDate = true" :placeholder="endPlaceholder"/>
  <i class="material-icons small-font" v-show="typeof endDate !== 'undefined' && endDate !== null" v-on:click="removeEndDate">close</i>
</div>
</template>

<script>
import DatePicker from '@/components/shared/inputs/DatePicker'
import UnderlinedInput from '@/components/shared/inputs/UnderlinedInput'
import moment from 'moment'

export default {
  name: 'dates-filter',
  components: {
    DatePicker,
    UnderlinedInput
  },
  props: {
    canDateRange: {
      type: Boolean,
      default: true
    },
    startPlaceholder: {
      type: String
    },
    endPlaceholder: {
      type: String
    },
    minStartDate: {
      type: moment.Moment
    },
    maxStartDate: {
      type: moment.Moment
    },
    Value: {
      type: moment.Moment
    },
    maxEndDate: {
      type: moment.Moment
    },
    startDate: {
      type: moment.Moment,
      required: true
    },
    endDate: {
      type: moment.Moment
    },
    headerGradient: {
      type: String,
      default: 'gradient-donapp'
    },
    color: {
      type: String,
      default: '#3a86be'
    },
    // TODO: strange default
    onChange: {
      type: Function,
      default: data => console.log(JSON.stringify(data))
    }
  },
  data() {
    return {
      showStartDate: false,
      showEndDate: false,
      showTest: false
    }
  },
  model: {
    prop: 'value',
    event: 'updateValue'
  },
  methods: {
    startDateChanged: function(date) {
      this.onChange('startDate', moment.utc(date, 'DD-MM-YYYY'))
    },
    endDateChanged: function(date) {
      // this.onChange('endDate', moment.utc(date, 'DD-MM-YYYY').add(1, 'days'))
      this.onChange('endDate', moment.utc(date, 'DD-MM-YYYY'))
    },
    removeStartDate: function() {
      this.onChange('startDate', null)
    },
    removeEndDate: function() {
      this.onChange('endDate', null)
    },
    formatDate(date) {
      return moment.utc(date).format('DD-MM-YYYY')
    }
  },
  computed: {
    minEndDateValue: function() {
      return this.startDate ? this.startDate.add('1', 'days').format('YYYY-MM-DD') : null
    },
    maxStartDateValue: function() {
      return this.endDate ? this.endDate.subtract('1', 'days').format('YYYY-MM-DD') : null
    },
    startDateValue: {
      get: function() {
        return this.startDate ? this.startDate.format('YYYY-MM-DD') : this.$t('datatables.date_placeholder')
      },
      set: function(newValue) {}
    },
    endDateValue: {
      get: function() {
        return this.endDate ? this.endDate.format('YYYY-MM-DD') : this.$t('datatables.date_placeholder')
      },
      set: function(newValue) {}
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../scss/config.scss';

.date-filters {
  display: flex;
  align-items: center;
}

.date-filters > * {
  margin-right: 8px;
}

.small-font {
  font-size: 14px;
}

.material-icons {
  cursor: pointer;
}

.material-icons.calendar {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/DatesFilter.vue